import React, { useRef, useState } from "react"
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Box, Link, Stack, Typography } from "@mui/material"
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { LiaSignOutAltSolid } from "react-icons/lia";
import { IoSettingsOutline } from "react-icons/io5";

import BaseLink from "../BaseLink"
import BaseImage from "../BaseImage"
import BaseButton from "../BaseButton";
// import Notification from "../Notification"
// import AppSearchInput from "../AppSearchInput";
// import OnlineChat from "../OnlineChat";

import LogoBlack from "../../assets/images/logo/dDNA_logo_black.svg"
import IconSupport from "../../assets/images/icons/icon-support.svg"
import IconFaq from "../../assets/images/icons/icon-faq.svg"
import { logout } from "../../api-services/auth";
import { useOutsideAlerter } from "../../hooks/use-outside-alerter";

const Header = () => {
  const navigate = useNavigate()
  const containerRef = useRef(null);
  const auth = useSelector(state => state.auth)

  const [showDropdown, setShowDropdown] = useState(false)

  useOutsideAlerter(containerRef, setShowDropdown);

  const handleClickSignOut = async () => {
    await logout()
    navigate('/login')
  }

  return (
    <Box
      ref={containerRef}
      component="nav"
      sx={{
        bgcolor: 'background.default',
        width: '100%',
        height: '80px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'fixed',
        top: 0,
        zIndex: 100,
        px: '40px'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <BaseLink to='/'>
          <BaseImage
            sx={{
              width: '80px',
              height: '35px',
              ml: '10px'
            }} 
            src={LogoBlack}
            alt="header-logo"
          />
        </BaseLink>
      </Box>
      <Stack direction="row" spacing={1}>
        {/* <BaseLink to='/profile'> */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end'
              }}
            >
              <Typography variant="h4" color='primary.darkGray'>
                {auth && `${auth?.firstName} ${auth?.lastName}`}
              </Typography>
              <Typography variant="body" color='primary.darkGray'>
                {`NPI: ${auth?.staffProfile?.npi || 'XXXXX'}`}
              </Typography>
            </Box>
            <BaseImage 
              sx={{
                width: '48px',
                height: '48px',
                ml: '10px',
                borderRadius: '50px',
                bgcolor: '#D9D9D9',
                cursor: 'pointer'
              }}
              sximage={{
                borderRadius: '50px',
                objectFit: 'cover'
              }}
              src={auth?.avatarUrl || IconSupport}
              alt="user-avatar"
              onClick={() => setShowDropdown(!showDropdown)}
            />
          </Box>
        {/* </BaseLink> */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <KeyboardArrowDownIcon 
            sx={{
              fontSize: '24px',
              color: 'primary.black',
              cursor: 'pointer'
            }}
            onClick={() => setShowDropdown(!showDropdown)}
          />
          <Stack
            direction={'column'}
            spacing={'8px'}
            sx={{
              display: showDropdown ? 'flex' : 'none',
              position: 'absolute',
              right: 10,
              top: '80px',
              borderRadius: '8px',
              bgcolor: 'primary.white',
              border: '1px solid',
              borderColor: 'primary.mediumGray',
              padding: '8px',
              boxShadow: '0px 2px 10px 0px #5B87EF33'
            }}
          >
            <BaseLink to="/settings"> 
              <BaseButton
                sx={{
                  height: { xs: '39px', md: '39px' },
                  color: "primary.black",
                  padding: '8px 16px',
                  justifyContent: 'flex-start',
                  boxShadow: '0',
                  '&:hover': {
                    bgcolor: 'background.default'
                  },
                  '&:active': {
                    bgcolor: 'primary.lightBlue'
                  },
                }}
              >
                <IoSettingsOutline size={24} />
                <Typography
                  variant="body"
                  color="primary.black"
                  sx={{
                    ml: '10px'
                  }}
                >
                  Settings
                </Typography>
              </BaseButton>
            </BaseLink>
            <BaseLink to="/faq"> 
              <BaseButton
                sx={{
                  height: { xs: '39px', md: '39px' },
                  color: "primary.black",
                  padding: '8px 16px',
                  justifyContent: 'flex-start',
                  boxShadow: '0',
                  '&:hover': {
                    bgcolor: 'background.default'
                  },
                  '&:active': {
                    bgcolor: 'primary.lightBlue'
                  },
                }}
              >
                <BaseImage
                  src={IconFaq}
                  sximage={{
                    width: '24px',
                    height: '24px'
                  }}
                />
                <Typography
                  variant="body"
                  color="primary.black"
                  sx={{
                    ml: '10px'
                  }}
                >
                  FAQs
                </Typography>
              </BaseButton>
            </BaseLink>
            <BaseButton
              sx={{
                height: { xs: '39px', md: '39px' },
                color: "primary.black",
                padding: '8px 16px',
                justifyContent: 'flex-start',
                boxShadow: '0',
                '&:hover': {
                  bgcolor: 'background.default'
                },
                '&:active': {
                  bgcolor: 'primary.lightBlue'
                },
              }}
              onClick={handleClickSignOut}
            >
              <LiaSignOutAltSolid size={24} />
              <Typography
                variant="body"
                color='primary.darkBlack'
                sx={{
                  ml: '10px'
                }}
              >
                Sign out
              </Typography>
            </BaseButton>
            <Box
              sx={{
                padding: '8px 16px',
                borderTop: '1px solid',
                borderColor: 'primary.mediumGray',
              }}
            >
              <Typography variant="subText">
                Help:{' '}
                <Link
                  href='mailto:help@descendantsdna.com'
                  sx={{
                    color: 'primary.black',
                    textDecoration: 'underline',
                    cursor: 'pointer'
                  }}
                >
                  help@descendantsdna.com
                </Link>
              </Typography>
            </Box>
          </Stack>
        </Box>
      </Stack>
    </Box>
  )
}

export default Header